import * as XLSX from 'xlsx';

export interface ExcelExportOptions {
  filename: string;
  sheetName?: string;
  data: any[][];
}

export const exportToExcel = ({ filename, sheetName = 'Sheet1', data }: ExcelExportOptions) => {
  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Apply styling - bold header row and borders
  const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
  
  // Style all cells with borders
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[address]) continue;
      
      ws[address].s = {
        border: {
          top: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } }
        },
        font: R === 0 ? { bold: true } : undefined
      };
    }
  }

  // Set column widths
  const colWidths = data[0].map((_, colIndex) => {
    const maxLength = data.reduce((max, row) => {
      const cellValue = String(row[colIndex] || '');
      return Math.max(max, cellValue.length);
    }, 10);
    return { wch: Math.min(maxLength + 2, 50) };
  });
  ws['!cols'] = colWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // Generate and download file
  XLSX.writeFile(wb, filename);
};
